import { useEffect, useState } from 'react';

/** Renders `value` as a QR code (PNG data URL). qrcode is loaded on demand. */
export default function QrCode({ value, size = 320, className }: { value: string; size?: number; className?: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    setDataUrl(null); setErr('');
    import('qrcode')
      .then((m) => m.default.toDataURL(value, { width: size * 2, margin: 2, errorCorrectionLevel: 'M' }))
      .then((url) => { if (alive) setDataUrl(url); })
      .catch(() => { if (alive) setErr('Could not render QR'); });
    return () => { alive = false; };
  }, [value, size]);

  if (err) return <div className="muted">{err}</div>;
  if (!dataUrl) return <div className="spinner" style={{ width: 24, height: 24, margin: `${size / 2 - 12}px auto` }} />;
  return <img className={className} src={dataUrl} alt={`QR for ${value}`} width={size} height={size} style={{ display: 'block' }} />;
}

/** Build a QR PNG data URL (for download). */
export async function qrDataUrl(value: string, px = 900): Promise<string> {
  const m = await import('qrcode');
  return m.default.toDataURL(value, { width: px, margin: 2, errorCorrectionLevel: 'M' });
}
